import { createFcmExperimentsContext } from 'src/app/shared/contexts/experiment';
import type { LoadedStateData } from 'src/app/shared/utils/async';

import {
	FCM_EXPERIMENT_SHARE_COPY_HEADLINES_WHATSAPP,
	FCM_EXPERIMENT_SIGNATURE_GROWTH_PSF_FB_SHARE_HEADLINES,
} from './config';

export const {
	FcmExperimentsContext: PsfSharePageFcmExperimentsContext,
	FcmExperimentsProvider: PsfSharePageFcmExperimentsContextProvider,
	useFcmExperiments: usePsfSharePageFcmExperiments,
	useAsyncFcmExperiments: useAsyncPsfSharePageFcmExperiments,
	prefetchFcmExperiments: prefetchPsfSharePageFcmExperiments,
} = createFcmExperimentsContext({
	name: 'PsfSharePageFcmExperimentsContext',
	dataProperty: 'pageFcmExperiments',
	configs: {
		whatsAppExperiment: FCM_EXPERIMENT_SHARE_COPY_HEADLINES_WHATSAPP,
		facebookHeadlineExperiment: FCM_EXPERIMENT_SIGNATURE_GROWTH_PSF_FB_SHARE_HEADLINES,
	},
	prefetch: true,
});

export type PsfSharePageFcmExperimentsState = ReturnType<typeof useAsyncPsfSharePageFcmExperiments>;
export type PsfSharePageFcmExperiments = LoadedStateData<PsfSharePageFcmExperimentsState>;
